import { FC } from "react";
import { noop } from "@common/helpers/function";
import { StandardModal } from "@design-system/Modal/Modal";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useOverlays } from "contexts/OverlayContext";
import { AddClientDrawer } from "./AddClientDrawer";
import { AddClientModal } from "./AddClientModal";

export const AddClientOverlayContainer: FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const { newAddClientFlow } = useTypedFlags();
    const overlayInfo = getOverlayInfo("addClient");

    if (!overlayInfo) {
        return null;
    }

    if (newAddClientFlow) {
        return (
            <AddClientDrawer
                key={overlayInfo.instanceId}
                open={!overlayIsClosing}
                onClose={closeOverlay}
                onAnimationEnd={noop}
            />
        );
    }

    return (
        <StandardModal
            backdrop="static"
            show={!overlayIsClosing}
            onHide={closeOverlay}
        >
            <AddClientModal onClose={closeOverlay} />
        </StandardModal>
    );
};
